import { type ReactElement, StrictMode } from 'react';
import { hydrateRoot, type Root } from 'react-dom/client';
import ReactModal from 'react-modal';
import { loadableReady } from '@loadable/component';

import { CHUNK_LOADING_GLOBAL } from 'constants/loadable';
import { logger } from 'logger';

type HydrationConfig = {
  appElement: ReactElement;
  loggerName: 'fragment' | 'page';
  contentRoot: HTMLElement;
  namespace: string;
};

export const hydrateClient = async ({
  appElement,
  loggerName,
  contentRoot,
  namespace,
}: HydrationConfig): Promise<Root | null> => {
  if (!namespace || !contentRoot) {
    const error = new Error(
      'Content Renderer: Root container, content root, or namespace not found',
    );

    logger.error(
      Object.assign(error, {
        logger: `ContentRenderer | ${loggerName}`,
        section: 'Hydration Error',
      }),
    );

    return null;
  }

  ReactModal.setAppElement(contentRoot);

  return loadableReady(undefined, { namespace, chunkLoadingGlobal: CHUNK_LOADING_GLOBAL }).then(
    () =>
      hydrateRoot(contentRoot, <StrictMode>{appElement}</StrictMode>, {
        identifierPrefix: `wtr-cr-${namespace}`,
      }),
  );
};
